import { useCallback } from 'react';

import {
  ApprovalStepState,
  ApprovalStepStatus,
  EmploymentDetailsProposalProps,
} from '~/data/proposals';
import { EmployeeProposalDecision } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

type PropsType = {
  proposal: EmploymentDetailsProposalProps;
  onSubmit: (
    proposal: EmploymentDetailsProposalProps,
    decision?: EmployeeProposalDecision,
  ) => void;
};

export const useEmployeeProposal = (props: PropsType) => {
  const { proposal, onSubmit } = props;

  const convertApprovalStepStateToDecision = (
    updatedApprovalStep: ApprovalStepState,
  ): EmployeeProposalDecision | undefined => {
    switch (updatedApprovalStep.state) {
      case ApprovalStepStatus.APPROVED:
        return EmployeeProposalDecision.Approve;
      case ApprovalStepStatus.REJECTED:
        return EmployeeProposalDecision.Reject;
      default:
        return undefined;
    }
  };

  const handleDecision = useCallback(
    (updatedApprovalStep: ApprovalStepState) => {
      const decision = convertApprovalStepStateToDecision(updatedApprovalStep);
      onSubmit(proposal, decision);
    },
    [onSubmit, proposal],
  );

  const handleUltimateDecision = useCallback(
    (updatedApprovalSteps: ApprovalStepState[]) => {
      // Approve or reject by submitting the related proposal form
      const decision = updatedApprovalSteps.map((step) =>
        convertApprovalStepStateToDecision(step),
      )[0];
      onSubmit(proposal, decision);
    },
    [onSubmit, proposal],
  );

  return {
    handleDecision,
    handleUltimateDecision,
  };
};
